export default "__VITE_ASSET__jrET9BJJ__"